import { Component, input } from '@angular/core';
import { Components } from '../../../components';
import { DynamicModule } from 'ng-dynamic-component';
import { OfferingHosting } from '../../../models/offering';

@Component({
  selector: 'inexp-offering-details-specification',
  imports: [DynamicModule],
  templateUrl: './offering-details.component.html',
  styleUrl: './offering-details.component.scss',
})
export class OfferingDetailsComponent {
  components = Components;

  // General
  _uid = input<string>();
  component = input<string>();
  section = input<string>();
  approvalStatus = input<string>();
  licenseCostResponsibility = input<string>();
  additionalCostConsiderations = input<string>();
  otherPricingModels = input<string>();
  isPerUserPricingAvailable = input<boolean | null>();
  perUserCostValue = input<string>();
  perUserCostCurrency = input<string>();
  perUserCostFrequency = input<string>();
  classificationLevel = input<string>();
  classificationRetentionPeriod = input<string>();
  applicationType = input<string>();
  hosting = input<OfferingHosting>();
  singleSignOnIsSupported = input<boolean | null>();
  singleSignOnProviders = input<string[]>();
  gxp = input<boolean | null>();
  systemRiskAssessmentName = input<string>();
  systemRiskAssessmentUrl = input<string>();
  isSupported = input<boolean | null>();
  geographicAvailability = input<string[]>();
  agentName = input<string>();
  agentUrl = input<string>();
  supportUrl = input<string>();

  // Infrastructure
  qualificationStatus = input<string>();
  developmentCostResponsibility = input<string>();
  developmentCostResponsibilityOtherDetails = input<string>();
  supportMaintenanceCostResponsibility = input<string>();
  supportMaintenanceCostResponsibilityOtherDetails = input<string>();

  // Platform
  systemRiskAssessmentForSolutions = input<boolean>();
  supportedDataClassificationLevel = input<string>();
  isExternalUseAllowed = input<boolean>();

}
